import { render, staticRenderFns } from "./CreateAgreementAdditionalItemsModal.vue?vue&type=template&id=be15562e&"
import script from "./CreateAgreementAdditionalItemsModal.vue?vue&type=script&lang=js&"
export * from "./CreateAgreementAdditionalItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports